export enum DocumentSubFolderName {
    Final = 'final',
    Upload = 'upload',
    Original = 'original',
    Signed = 'signed',
    FileAttached = 'attached',
    Docx = 'docx'
}